<script>
import { filter } from 'lodash-es';

export default {
    props: {
        input: {
            type: Object,
            required: true,
        },
        placeholder: {
            type: String,
            default: ''
        },
        items: {
            type: Array,
            required: true
        },
        values: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            toggled: false,
            listIndex: -1,
        }
    },
    methods: {
        toggle ($event) {
            if ($event.target.classList.contains('auto-complete__input-field')) {
                this.toggled = !this.toggled;

                if (this.toggled) {
                    this.$nextTick(() => {
                        document.addEventListener('click', this.close);
                    });
                }
            }
        },
        change(value) {
            this.$emit('change', value);
        },
        filteredList() {
            return filter(this.items, item => {
                const inputLower = this.input.name ? this.input.name.toLowerCase() : '';
                let exist = filter(this.values, value => {
                    return (value.name ? value.name.toLowerCase() : '') === item.name.toLowerCase() && (value.id === item.id);
                }).length > 0;
                if (item.area) {
                    return !exist && ((item.name.toLowerCase().indexOf(inputLower) !== -1) || (item.area.toLowerCase().indexOf(inputLower) !== -1));
                } else {
                    return !exist && item.name.toLowerCase().indexOf(inputLower) !== -1 && item.name.toLowerCase() !== inputLower;
                }
            });
        },
        select(value) {
            this.toggled = false;
            this.$emit('change', value);
        },
        keys(key) {
            switch (key) {
            case 'ArrowDown':
                this.scroll();
                this.listIndex < this.filteredList().length - 1 ? this.listIndex++ : null;
                break;
            case 'ArrowUp':
                this.scroll();
                this.listIndex > -1 ? this.listIndex-- : null;
                break;
            case 'Enter':
                this.toggled = false;
                if(this.listIndex !== -1) {
                    this.$emit('change', this.filteredList()[this.listIndex]);
                    this.listIndex = -1;
                }
                break;
            case 'Backspace':
                this.toggled = true;
                break;
            case 'Escape':
                this.toggled = false;
                break;
            default:
                break;
            }
        },
        hide() {
            if(this.listIndex === -1) {
                this.toggled = false;
            }
        },
        scroll() {
            let listElement = document.getElementById('auto-complete__list');
            listElement.scrollTop = (this.listIndex * 50) - 50;
        },
        close ($event) {
            this.toggled = false;
            $event.currentTarget.removeEventListener('click', this.close);
        }
    }
}
</script>
<template>
    <div class="auto-complete">
        <div class="auto-complete__content">
            <div class="auto-complete__input">
                <span v-if="input.name && !input.id" class="auto-complete__input-icon">
                    <i class="fa fa-exclamation-triangle"/>
                </span>
                <input :placeholder="placeholder"
                       :value="input.name"
                       class="auto-complete__input-field"
                       type="text"
                       @click="toggle($event)"
                       @input="change({name: $event.target.value, id: null})"
                       @keydown="keys($event.key)"
                       @blur="hide()"
                >
            </div>
            <div class="auto-complete__drop-down">
                <div v-if="toggled" id="auto-complete__list" class="auto-complete__list">
                    <div v-for="(item, index) in filteredList()"
                         :class="{'auto-complete__choice--active' : index === listIndex}"
                         :key="index"
                         class="auto-complete__choice"
                         @click="select(item)"
                         @mouseenter="listIndex = index"
                         @mouseleave="listIndex = -1"
                    >
                        <span class="auto-complete__item-value">
                            {{ item.name }}
                            <span v-if="item.area"> ({{ item.area }})</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/AutoComplete/AutoComplete.vue